export const socketInprogressServiceStatus = Object.freeze({
    COMPLETED: "completed",
    RETRY: "retry",
    FAILED: "failed",
    INPROGRESS: "inprogress"
});